// extracted by mini-css-extract-plugin
module.exports = {"container":"PointOfInterestMarker_container__23Vfv","hovered":"PointOfInterestMarker_hovered__1b5Jr"};